import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StudentMigrationRoutingModule } from './student-migration-routing.module';
import { MigrationEntryComponent } from './migration-entry/migration-entry.component';
import { MigrationLandingComponent } from './migration-landing/migration-landing.component';
import { MigrationLinkComponent } from './migration-link/migration-link.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { AgGridModule } from 'ag-grid-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgxSpinnerModule } from 'ngx-spinner';



@NgModule({
  declarations: [
    MigrationEntryComponent,
    MigrationLandingComponent,
    MigrationLinkComponent,
   
  ],
  imports: [
    CommonModule,
    StudentMigrationRoutingModule,
    AcademicFormModule,
    AgGridModule,
    // ReactiveFormsModule,
    // FormsModule,
    ReactiveFormsModule,
    FormsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
  
  ]
})
export class StudentMigrationModule { }
